import BankkodeField from './felter/BankkodeField';
import AdresseFields from './felter/AdresseFields';

const AmerikanskKonto = () => {
    return (
        <>
            <BankkodeField />
            <AdresseFields />
        </>
    );
};

export default AmerikanskKonto;
